module.exports = __webpack_public_path__ + "img/DE.373a58b7.svg";